<div data-test-automation="tenure-parent-plan-type">
    <label class="control-label required-input">{{label}}</label>
    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
        <div>
            <ng-select
                class="nlr-ng-select"
                [searchable]="false"
                [clearable]="false"
                [disabled]="readonly ||(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                [name]="'parentPlanType'+name"
                [id]="'parentPlanType'+name"
                placeholder="Select"
                [items]="parentPlanTypeOptions"
                bindLabel="name"
                [ngModel]="parentPlanType"
                (change)="onSelectParentPlanType($event)"
                required>
            </ng-select>
        </div>
    }
</div>
